import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Grid2,
} from "@mui/material";

import { ReactComponent as Download } from "../../../../../../../GlobalAssets/svg/Download.svg";
import TooltipType from "../../../../../../../GlobalComponents/TooltipComponent/TooltipComponent";
import styles from "./AlertsTable.module.scss";

const AlertsTable = (props) => {
  const { rows } = props;

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const handleChangePage = (newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const paginatedRows = rows.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const DownloadRestoreButton = ({ title, IconComponent, onClick }) => (
    <Grid2 className={styles.iconBox} onClick={onClick}>
      <TooltipType title={title} arrow placement="top">
        <IconComponent />
      </TooltipType>
    </Grid2>
  );

  return (
    <Grid2>
      <TableContainer className={styles.main}>
        <Table>
          <TableHead className={styles.tableHead}>
            <TableRow className={styles.tablerow}>
              <TableCell>
                <Grid2 className={styles.name}>Date & Time</Grid2>
              </TableCell>
              <TableCell>
                <Grid2 className={styles.tableHeaderText}>Alert Type</Grid2>
              </TableCell>
              <TableCell>
                <Grid2 className={styles.created}>Severity</Grid2>
              </TableCell>
              <TableCell>
                <Grid2 className={styles.tableHeaderText}>
                  Download Log file
                </Grid2>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedRows.map((item, index) => (
              <TableRow key={index} className={styles.row}>
                <TableCell>
                  <Grid2 className={styles.tableHeaderText}>{item.date}</Grid2>
                </TableCell>
                <TableCell>
                  <Grid2 className={styles.type}>{item.type}</Grid2>
                </TableCell>
                <TableCell>
                  <Grid2 className={styles.sever}>{item.severity}</Grid2>
                </TableCell>
                <TableCell>
                  <Grid2 className={styles.download}>
                    <DownloadRestoreButton
                      title="Download"
                      IconComponent={Download}
                      onClick={() => item.download}
                    />
                  </Grid2>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <TablePagination
          component="div"
          count={rows.length}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[5, 10, 15]}
        />
      </TableContainer>
    </Grid2>
  );
};

export default AlertsTable;
